import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['upgradeAIRewriteModalShown', 'upgradeAIRewriteModalClick'] as const;

export const aiRewriteEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
